import A from "@babel/runtime/helpers/esm/slicedToArray";
import D from "@babel/runtime/helpers/esm/objectSpread2";
import x from "@babel/runtime/helpers/esm/classCallCheck";
import I from "@babel/runtime/helpers/esm/createClass";
import f from "@babel/runtime/helpers/esm/assertThisInitialized";
import C from "@babel/runtime/helpers/esm/inherits";
import k from "@babel/runtime/helpers/esm/createSuper";
import l from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as M } from "@semcore/utils/lib/core/index";
import z, { sstyled as w, assignProps as R, Component as $ } from "@semcore/core";
import g from "react";
import V from "@semcore/input";
import { IncrementIcon as W, DecrementIcon as K } from "./buttons.mjs";
import { localizedMessages as F } from "./translations/__intergalactic-dynamic-locales.mjs";
import L from "@semcore/utils/lib/enhances/i18nEnhance";
import { forkRef as B } from "@semcore/utils/lib/ref";
import { callAllEventHandlers as G } from "@semcore/utils/lib/assignProps";
var N = (
  /*__reshadow_css_start__*/
  (M.insert(
    /*__inner_css_start__*/
    ".___SValue_1fgoh_gg_:focus~.___SControls_1fgoh_gg_{display:flex}.___SControls_1fgoh_gg_{display:none;flex-flow:column;justify-content:center;height:100%;box-sizing:border-box}.___SControls_1fgoh_gg_.__showControls_1fgoh_gg_{display:flex}.___SDown_1fgoh_gg_,.___SUp_1fgoh_gg_{padding:0;width:16px;color:var(--intergalactic-icon-secondary-neutral, #a9abb6);box-sizing:border-box;display:inline-flex;justify-content:center;border:0;background:0 0;cursor:pointer}.___SDown_1fgoh_gg_:focus,.___SUp_1fgoh_gg_:focus{outline:0}@media (hover:hover){.___SDown_1fgoh_gg_:hover,.___SUp_1fgoh_gg_:hover{color:var(--intergalactic-icon-secondary-neutral-hover-active, #878992)}}.___SUp_1fgoh_gg_{padding-bottom:1px}.___SDown_1fgoh_gg_{padding-top:1px}.___SValue_1fgoh_gg_::-webkit-inner-spin-button,.___SValue_1fgoh_gg_::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.___SValue_1fgoh_gg_._type_number_1fgoh_gg_{-moz-appearance:textfield}.___SValue_1fgoh_gg_.__disabled_1fgoh_gg_~.___SControls_1fgoh_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___SValueHidden_1fgoh_gg_{position:absolute;top:0;width:1px;height:1px;padding:0;overflow:hidden}",
    "1fgoh_gg_"
  ), {
    __SValue: "___SValue_1fgoh_gg_",
    __SControls: "___SControls_1fgoh_gg_",
    _showControls: "__showControls_1fgoh_gg_",
    __SUp: "___SUp_1fgoh_gg_",
    __SDown: "___SDown_1fgoh_gg_",
    _disabled: "__disabled_1fgoh_gg_",
    __SValueHidden: "___SValueHidden_1fgoh_gg_",
    _type_number: "_type_number_1fgoh_gg_"
  })
);
function H(h) {
  var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MIN_SAFE_INTEGER, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.MAX_SAFE_INTEGER;
  return Math.max(v, Math.min(c, h));
}
var P = /* @__PURE__ */ function(h) {
  C(c, h);
  var v = k(c);
  function c() {
    var r;
    x(this, c);
    for (var n = arguments.length, s = new Array(n), i = 0; i < n; i++)
      s[i] = arguments[i];
    return r = v.call.apply(v, [this].concat(s)), l(f(r), "inputRef", /* @__PURE__ */ g.createRef()), l(f(r), "increment", function(e) {
      var t, a;
      (t = r.inputRef.current) === null || t === void 0 || (a = t.stepUp) === null || a === void 0 || a.call(t, e);
    }), l(f(r), "decrement", function(e) {
      var t, a;
      (t = r.inputRef.current) === null || t === void 0 || (a = t.stepDown) === null || a === void 0 || a.call(t, e);
    }), r;
  }
  return I(c, [{
    key: "getValueProps",
    value: function() {
      var n = new Intl.NumberFormat(this.asProps.locale, {
        style: "decimal"
      });
      return {
        inputRef: this.inputRef,
        increment: this.increment,
        decrement: this.decrement,
        numberFormatter: n
      };
    }
  }, {
    key: "getControlsProps",
    value: function() {
      var n = this.asProps, s = n.size, i = n.getI18nText;
      return {
        size: s,
        increment: this.increment,
        decrement: this.decrement,
        getI18nText: i
      };
    }
  }, {
    key: "render",
    value: function() {
      var n = this.asProps, s, i = V;
      return s = w(this.asProps.style), /* @__PURE__ */ g.createElement(i, s.cn("SInputNumber", D({}, R({}, n))));
    }
  }]), c;
}($);
l(P, "displayName", "InputNumber");
l(P, "style", N);
l(P, "enhance", [L(F)]);
l(P, "defaultProps", {
  size: "m",
  i18n: F,
  locale: "en"
});
var E = /* @__PURE__ */ function(h) {
  C(c, h);
  var v = k(c);
  function c() {
    var r;
    x(this, c);
    for (var n = arguments.length, s = new Array(n), i = 0; i < n; i++)
      s[i] = arguments[i];
    return r = v.call.apply(v, [this].concat(s)), l(f(r), "valueInputRef", /* @__PURE__ */ g.createRef()), l(f(r), "cursorPosition", -1), l(f(r), "getFormattedValue", function(e) {
      return e.replace(new RegExp("[".concat(r.separatorThousands, "]"), "g"), "").replace(r.separatorDecimal, ".");
    }), l(f(r), "valueParser", function(e, t, a) {
      var u = r.props.numberFormatter, o = r.getFormattedValue(String(e));
      if (Number.isNaN(Number(o)))
        return {
          parsedValue: t,
          displayValue: a
        };
      var d = "";
      if (/\.[0-9]*0$/.test(o)) {
        var p = o.split(r.separatorDecimal), _ = A(p, 2), m = _[0], S = _[1];
        d = u.format(m) + r.separatorDecimal + S;
      } else o !== "" && (d = u.format(o));
      return {
        parsedValue: o,
        displayValue: d
      };
    }), l(f(r), "handleValidation", function(e) {
      var t = r.asProps, a = t.value, u = t.displayValue, o = t.min, d = t.max, p = t.step, _ = r.valueParser(e.currentTarget.value, a, u), m = _.parsedValue, S = p < 1 ? p.toString().split(".")[1].length : 1;
      if (Number.isNaN(a) || Number.isNaN(Number.parseFloat(m)))
        e.currentTarget.value = "", r.handlers.value("", e);
      else {
        var y = H(Number.parseFloat(m), o, d), b = r.round(y % p, p);
        b !== 0 && (b >= p / 2 ? y += p - b : Math.abs(b) < p && (y -= b));
        var U = Number(y.toFixed(S));
        r.handlers.value(String(U), e);
      }
    }), l(f(r), "onWheel", function(e) {
      G(r.asProps.onWheel, r.handleWheel)(e);
    }), l(f(r), "handleWheel", function(e) {
      e.target === r.valueInputRef.current && document.activeElement === r.valueInputRef.current && (e.preventDefault(), e.wheelDelta > 0 ? r.stepUp(e) : e.wheelDelta < 0 && r.stepDown(e));
    }), l(f(r), "handleChange", function(e) {
      var t = r.getFormattedValue(e.currentTarget.value), a = r.asProps, u = a.numberFormatter, o = a.value;
      if (t === "." || t === "-")
        return r.handlers.displayValue(t), !1;
      if (t.endsWith("-"))
        return !1;
      if (t.endsWith("."))
        return t.length > o.length ? (r.handlers.displayValue(u.format(t) + r.separatorDecimal), !1) : (r.handlers.value(t.slice(0, -1), e), !1);
      var d = /[0-9.-]+/.test(t);
      (d || t === "") && r.handlers.value(t, e);
    }), l(f(r), "handleKeyUp", function(e) {
      e.key === "Shift" && (r.cursorPosition = -1);
    }), l(f(r), "handleKeyDown", function(e) {
      var t = e.currentTarget, a = t.value, u = a.length, o = r.asProps.displayValue;
      if (e.key === "." || e.key === ",") {
        if (a.indexOf(r.separatorDecimal) === -1 && e.key === ",")
          e.currentTarget.value = a + ".";
        else if (a.indexOf(r.separatorDecimal) !== -1) {
          e.preventDefault(), e.stopPropagation();
          return;
        }
      }
      if (e.key === "Backspace" && a.endsWith(r.separatorDecimal))
        return e.preventDefault(), e.stopPropagation(), r.handlers.displayValue(o.slice(0, -1)), !1;
      if (t.selectionStart !== u && (e.key === "Backspace" || e.key === r.separatorDecimal || ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key))) {
        var d = a.slice(t.selectionEnd);
        requestAnimationFrame(function() {
          var _ = r.state.displayValue, m = _.lastIndexOf(d), S = m, y = m;
          t.setSelectionRange(S, y);
        });
      }
      var p = 2;
      switch (e.shiftKey && r.cursorPosition === -1 && (r.cursorPosition = t.selectionStart), e.key) {
        case "ArrowLeft": {
          e.preventDefault(), r.moveSelectionLeft(t, p);
          break;
        }
        case "ArrowRight": {
          e.preventDefault(), r.moveSelectionRight(t, p);
          break;
        }
        case "ArrowDown": {
          e.preventDefault(), r.stepDown(e);
          break;
        }
        case "ArrowUp": {
          e.preventDefault(), r.stepUp(e);
          break;
        }
      }
    }), l(f(r), "moveSelectionLeft", function(e, t) {
      var a = e.value, u = e.selectionStart - 1 >= 0 ? e.selectionStart - 1 : 0, o = a[e.selectionStart - t] === r.separatorThousands ? e.selectionStart - t : u;
      r.cursorPosition === -1 ? e.setSelectionRange(o, o) : e.selectionStart <= r.cursorPosition && e.selectionEnd === r.cursorPosition ? e.setSelectionRange(o, e.selectionEnd) : e.setSelectionRange(e.selectionStart, a[e.selectionEnd - t] === r.separatorThousands ? e.selectionEnd - t : e.selectionEnd - 1);
    }), l(f(r), "moveSelectionRight", function(e, t) {
      var a = e.value, u = e.selectionEnd + 1, o = a[e.selectionEnd] === r.separatorThousands ? e.selectionEnd + t : u;
      r.cursorPosition === -1 ? e.setSelectionRange(o, o) : e.selectionEnd >= r.cursorPosition && e.selectionStart === r.cursorPosition ? e.setSelectionRange(e.selectionStart, o) : e.setSelectionRange(a[e.selectionStart] === r.separatorThousands ? e.selectionStart + t : e.selectionStart + 1, e.selectionEnd);
    }), l(f(r), "handleClick", function(e) {
      var t = e.target, a = t.value;
      a[t.selectionStart - 1] === r.separatorThousands && t.setSelectionRange(t.selectionStart - 1, t.selectionEnd - 1);
    }), l(f(r), "handleBlur", function(e) {
      r.cursorPosition = -1, r.handleValidation(e);
    }), l(f(r), "stepUp", function(e) {
      var t = r.asProps, a = t.max, u = a === void 0 ? Number.MAX_SAFE_INTEGER : a, o = t.min, d = t.step, p = t.value, _;
      if (p === "" ? _ = o ?? 0 : _ = Number.parseFloat(p), !Number.isNaN(_)) {
        var m = _ + d <= u ? _ + d : u;
        r.handlers.value(m.toString(), e);
      }
    }), l(f(r), "stepDown", function(e) {
      var t = r.asProps, a = t.max, u = t.min, o = u === void 0 ? Number.MIN_SAFE_INTEGER : u, d = t.step, p = t.value, _;
      if (p === "" ? _ = a ?? 0 : _ = Number.parseFloat(p), !Number.isNaN(_)) {
        var m = _ - d >= o ? _ - d : o;
        r.handlers.value(m.toString(), e);
      }
    }), r;
  }
  return I(c, [{
    key: "uncontrolledProps",
    value: function() {
      var n = this;
      return {
        displayValue: null,
        value: [null, function(s) {
          var i = n.asProps, e = i.value, t = i.displayValue, a = n.valueParser(s, e, t), u = a.parsedValue, o = a.displayValue;
          return n.handlers.displayValue(o), u;
        }]
      };
    }
  }, {
    key: "separatorDecimal",
    get: function() {
      var n = this.props.numberFormatter;
      return n.format(11.11).replace(/\d/g, "");
    }
  }, {
    key: "separatorThousands",
    get: function() {
      var n = this.props.numberFormatter;
      return n.format(1111).replace(/\d/g, "");
    }
  }, {
    key: "round",
    value: function(n, s) {
      var i = Math.floor(s) === s ? 0 : s.toString().split(".")[1].length || 0;
      return i === 0 ? Number.parseFloat(n) : Number.parseFloat(n).toPrecision(i);
    }
  }, {
    key: "componentDidMount",
    value: (
      // https://stackoverflow.com/questions/57358640/cancel-wheel-event-with-e-preventdefault-in-react-event-bubbling
      function() {
        var n;
        (n = this.valueInputRef.current) === null || n === void 0 || n.addEventListener("wheel", this.onWheel);
        var s = this.asProps, i = s.inputRef, e = s.value;
        if (i.current && (i.current.stepUp = this.stepUp, i.current.stepDown = this.stepDown), e !== "") {
          var t = this.valueParser(e, "", ""), a = t.displayValue;
          this.handlers.displayValue(a);
        }
      }
    )
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      if (n.value !== this.props.value) {
        var s = this.valueParser(this.props.value, n.value, n.displayValue), i = s.displayValue;
        this.handlers.displayValue(i);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var n;
      (n = this.valueInputRef.current) === null || n === void 0 || n.removeEventListener("wheel", this.onWheel);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.asProps, s, i = V.Value, e = this.asProps, t = e.styles, a = e.min, u = e.max, o = e.step, d = e.forwardRef, p = e.inputRef, _ = e.displayValue;
      return s = w(t), /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(i, s.cn("SValue", D({}, R({
        autoComplete: "off",
        onBlur: this.handleValidation,
        "use:onChange": this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onClick: this.handleClick,
        "use:ref": B(this.valueInputRef, p, d),
        "use:value": _,
        inputMode: Number.isInteger(o) ? "numeric" : "decimal",
        min: a,
        max: u,
        step: o
      }, n)))));
    }
  }]), c;
}($);
l(E, "style", N);
l(E, "defaultProps", {
  defaultValue: "",
  defaultDisplayValue: "",
  step: 1
});
function T(h) {
  var v = arguments[0], c, r = h.Children, n = h.increment, s = h.decrement, i = h.size, e = h.styles, t = h.getI18nText, a = V.Addon, u = "button", o = "button";
  return c = w(e), /* @__PURE__ */ g.createElement(a, c.cn("SControls", D({}, R({
    "aria-hidden": "true"
  }, v))), /* @__PURE__ */ g.createElement(u, c.cn("SUp", {
    onClick: n,
    tabIndex: -1,
    type: "button",
    size: i,
    "aria-label": t("increment")
  }), /* @__PURE__ */ g.createElement(W, c.cn("IncrementIcon", {}))), /* @__PURE__ */ g.createElement(o, c.cn("SDown", {
    onClick: s,
    tabIndex: -1,
    type: "button",
    size: i,
    "aria-label": t("decrement")
  }), /* @__PURE__ */ g.createElement(K, c.cn("DecrementIcon", {}))), /* @__PURE__ */ g.createElement(r, c.cn("Children", {})));
}
T.style = N;
const ue = z(P, {
  Value: E,
  Controls: T,
  Addon: V.Addon
});
export {
  ue as default,
  H as parseValueWithMinMax
};
